import Stack from '@perpay-web/components/design-system/Stack/Stack';
import LazySpendingLimitAnimation from '@perpay-web/fintech/components/base/SpendingLimitAnimation/LazySpendingLimitAnimation';

import styles from './SpendingLimitLoader.scss';

const SpendingLimitLoader = () => (
    <Stack className={styles['loader-stack']}>
        <p className={styles['loader-heading']}>
            Calculating your spending limit...
        </p>
        <div className={styles.animation} data-chromatic='ignore'>
            <LazySpendingLimitAnimation />
        </div>
    </Stack>
);

export default SpendingLimitLoader;
